export default __webpack_public_path__ + "static/exp2-ed7db0c089cad634294b986f57e64cd4.webp";